import { VERSION_DETAILS_COPY } from "../constants/versionDetails.constants";
import { VersionDetailsSummaryParts } from "../types/versionHistory.types";

interface VersionDetailsSummaryProps {
  /** `null` when the version has no saved details -- the bar then shows nothing at all. */
  parts: VersionDetailsSummaryParts | null;
}

const SummaryItem = ({ label, value }: { label: string; value: string }) => (
  <span className="tw-whitespace-nowrap">
    <span className="tw-text-[10.5px] tw-uppercase tw-tracking-[0.08em]">{label}</span>{" "}
    <span className="tw-text-foreground">{value}</span>
  </span>
);

/** Compact read-only summary shown on a collapsed version bar. */
export const VersionDetailsSummary = ({ parts }: VersionDetailsSummaryProps) => {
  if (!parts) return null;

  return (
    <div className="tw-flex tw-items-center tw-gap-3 tw-text-xs tw-font-mono tw-text-muted-foreground tw-flex-wrap">
      <SummaryItem label={VERSION_DETAILS_COPY.summaryYearLabel} value={parts.year} />
      <span aria-hidden="true">{VERSION_DETAILS_COPY.summarySeparator}</span>
      <SummaryItem label={VERSION_DETAILS_COPY.summaryUnitsLabel} value={parts.units} />
      <span aria-hidden="true">{VERSION_DETAILS_COPY.summarySeparator}</span>
      <SummaryItem label={VERSION_DETAILS_COPY.summaryPriceLabel} value={parts.price} />
    </div>
  );
};
